module.exports = __webpack_public_path__ + "static/media/mail.33014dfb.svg";